module.exports = __webpack_public_path__ + "static/img/HAMBURG-MDF.2641d01.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/HAMBURG-MDF.png
// module id = 4SOk
// module chunks = 0